import React, { useMemo, useState } from "react";
import cn from "classnames";
import SendOTP from "./sendOtpCopy";
import BackIcon from "@/images/back_arrow.svg";
import { useTranslation } from "react-i18next";

export const MobileOtp: React.FC<{
  maskedNumber: string;
  emailFallback?: string;
  onBack: () => void;
  verifyEmailOtp: (
    code: string
  ) => Promise<{ success: boolean; message?: string }>;
  initialExpiresAtMs?: number | null;
  initialSendCount?: number;
  requestMobileOtp: () => Promise<any>;
  onSuccess?: () => void;
}> = ({
  maskedNumber,
  emailFallback,
  onBack,
  verifyEmailOtp,
  initialExpiresAtMs = null,
  initialSendCount = 1,
  requestMobileOtp,
  onSuccess
}) => {
  const { t } = useTranslation("auth");

  const [otp, setOtp] = useState("");
  const [otpValid, setOtpValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [verifyLoading, setVerifyLoading] = useState(false);

  const [sendCount, setSendCount] = useState(initialSendCount);
  const [expiresAtMs, setExpiresAtMs] = useState<number | null>(
    initialExpiresAtMs
  );
  const [resending, setResending] = useState(false);

  const sendOtp = async () => {
    if (resending) return;
    setResending(true);
    try {
      setErrorMessage("");
      setOtpValid(true);
      setOtp("");
      const res = await requestMobileOtp();
      if (!res.success) {
        setErrorMessage(res?.message || "Failed to send OTP");
        setOtpValid(false);
        return;
      }
      setExpiresAtMs(Date.now() + (res.retry ?? 0) * 1000);
      setSendCount(c => c + 1);
    } catch (e: any) {
      setErrorMessage(e?.response?.data?.message || "Failed to resend OTP");
      setOtpValid(false);
    } finally {
      setResending(false);
    }
  };

  const onVerify = async () => {
    setVerifyLoading(true);
    try {
      const resp = await verifyEmailOtp(otp);
      if (!resp?.success) {
        setOtpValid(false);
        setErrorMessage(resp?.message || "Invalid code");
        return;
      }
      onSuccess?.();
    } finally {
      setVerifyLoading(false);
    }
  };

  return (
    <div className="panel">
      <button className="mv_back" aria-label="Back" onClick={onBack}>
        <img src={BackIcon} style={{ height: "40px" }} />
      </button>

      <p className="mv_title">{t("mobileVerification")}</p>
      <p className="mv_text">
        {t("enter4DigitOtp")}
        <b className="masked_phone">{maskedNumber}</b>
      </p>

      <div className="panel_sendotp_wrap">
        <SendOTP
          phone={maskedNumber}
          otp={otp}
          handleOTPChange={setOtp}
          verifyOtp={onVerify}
          otpValid={otpValid}
          sendOtp={sendOtp}
          sendOtpCount={sendCount}
          errorMessage={errorMessage}
          showLoader={verifyLoading}
          expiresAtMs={expiresAtMs}
          showMobileVerification={false}
          resending={resending}
          showCaptcha={true}
        />
      </div>
    </div>
  );
};
